import { Modal_default } from "./chunk-7Q6G3GHT.js";
import { Modal_Header_default } from "./chunk-G7XUZDQO.js";
import { Modal_Content_default } from "./chunk-MRBY4VLI.js";
import { Modal_Footer_default } from "./chunk-4QNQUTHC.js";

// src/components/Modal/index.ts
var ModalComponent = Modal_default;
ModalComponent.Header = Modal_Header_default;
ModalComponent.Header.displayName = "Modal.Header";
ModalComponent.Content = Modal_Content_default;
ModalComponent.Content.displayName = "Modal.Content";
ModalComponent.Footer = Modal_Footer_default;
ModalComponent.Footer.displayName = "Modal.Footer";
export { ModalComponent };